import React, { useState, useEffect } from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import moment from 'moment';
import isString from 'lodash/isString';

import { Label } from 'components';
import { ReactComponent as Calendar } from 'assets/icons/calendar_purple.svg';
import { dateFormat } from 'utils';

const DatePicker = ({
  label,
  value,
  asterisk,
  placeholder,
  allowClear,
  iconPlacement = 'right',
  disabledDate = null,
  containerClassName,
  ...rest
}) => {
  const [width, setWidth] = useState(0);

  const formattedValue =
    value && isString(value) ? moment(value, 'DD/MM/YYYY') : value || null;

  useEffect(() => {
    const antPicker = document.querySelector('.ant-picker');
    // if (antPicker !== null) setWidth(antPicker.offsetWidth);
    if (antPicker !== null) setWidth('20%');
  }, []);
  return (
    <div className={`${containerClassName}`}>
      <Label label={label} asterisk={asterisk} />
      <AntDatePicker
        placeholder={placeholder}
        {...rest}
        prefix={
          iconPlacement === 'left' ? (
            <Calendar className="ant-calendar-icon" />
          ) : (
            ''
          )
        }
        suffixIcon={
          iconPlacement === 'right' ? (
            <Calendar className="ant-calendar-icon" />
          ) : (
            ''
          )
        }
        value={formattedValue}
        //disabledDate={d => !d || d.isAfter('2027-01-01')}
        //disabledDate={d => !d || d.isBefore(new Date((new Date()).valueOf() - 1000*60*60*24)) || d.isAfter('2027-01-01')}
        disabledDate={disabledDate ?? (d => !d)}
        format={dateFormat}
        allowClear={allowClear}
        onKeyDown={e => {
          e.preventDefault();
        }}
        popupStyle={{ width }}
      />
    </div>
  );
};

export default DatePicker;
